import { type FC, type ReactNode, useEffect, useState } from 'react';
import cn from 'classnames';
import {
    trackEvent,
    eventNameConstants,
    stepInteractionConstants,
    interactionTypeConstants,
} from 'dibs-tracking';

// components
import { Link } from 'dibs-elements/src/Link';
import { RotatingArrow } from 'dibs-elements/exports/RotatingArrow';
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';

// styles
import dibsCss from 'dibs-css';

const { STEP_INTERACTION_FACET_COLLAPSED, STEP_INTERACTION_FACET_EXPANDED } =
    stepInteractionConstants;

const trackSectionClick = (isExpanded: boolean, trigger: string): void =>
    trackEvent({
        eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
        interaction_type: interactionTypeConstants.INTERACTION_TYPE_PDP,
        step_interaction_name: isExpanded
            ? STEP_INTERACTION_FACET_EXPANDED
            : STEP_INTERACTION_FACET_COLLAPSED,
        trigger,
    });

export const PdpRespSidebarDetailsSection: FC<{
    title: ReactNode;
    children: ReactNode;
    ga: { trigger: string };
    expandedOnRender?: boolean;
    expandOverride?: boolean;
}> = ({ title, expandedOnRender, children, ga, expandOverride }) => {
    const [isSectionExpanded, setIsSectionExpanded] = useState<boolean>(expandedOnRender || false);

    useEffect(() => {
        if (expandOverride) {
            setIsSectionExpanded(true);
        }
    }, [expandOverride]);

    return (
        <>
            <Link
                className={dibsCss.wFull}
                buyerLinkType="linkNoDecoration"
                onClick={() => {
                    trackSectionClick(!isSectionExpanded, ga.trigger);
                    setIsSectionExpanded(!isSectionExpanded);
                }}
            >
                <div
                    className={cn(
                        dibsCss.flex,
                        dibsCss.ptSmall,
                        dibsCss.borderT,
                        dibsCss.textCenter,
                        dibsCss.borderTSolid,
                        dibsCss.justifyBetween,
                        dibsCss.borderTDolphin,
                        dibsCss.sassyFontBodyMediumHeavy,
                        {
                            [dibsCss.pbSmaller]: isSectionExpanded,
                            [dibsCss.pbSmall]: !isSectionExpanded,
                        }
                    )}
                >
                    <span>{title}</span>
                    <RotatingArrow direction={isSectionExpanded ? 'up' : 'down'} />
                </div>
            </Link>
            <ExpandingArea
                showOverflow
                expanded={isSectionExpanded}
                childrenWrapperClass={cn(dibsCss.sassyFontBodyMedium)}
            >
                <div className={dibsCss.mbSmall}>{children}</div>
            </ExpandingArea>
        </>
    );
};
